import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Modal, Tab } from 'react-bootstrap';
import CustomersSidebar from "./CustomersSidebar";
import UsersTable from "../Shared/UsersTable/UsersTable";
import Loader from '../Shared/Loader';
import { useUsersDispatch, useUsersState } from "store/hooks/users";
import { useRolesDispatch } from "store/hooks/roles";
import { useRouter } from 'helpers/customHooks';
import { ShortTeamsData } from './types';


class MyVerticallyCenteredModal extends React.Component<{ show: boolean, onHide: () => void}> {
  render() {
    return (
      <Modal
        className="modal-content-04"
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Team Zones
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Team Walk Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Jog Yards</p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Run Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Sprint Yards</p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Max Sprint Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <p>Team Max Sprint Yards </p>
          <div className="edit-team">
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      mph
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="icon-edit"><i className="mdi mdi-minus" /></div>
            <div>
              <div className="input-group">
                <input type="text" className="form-control" aria-label="Text input with dropdown button" />
                <div className="input-group-append">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      % of max
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="#/action-1">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-2">110</Dropdown.Item>
                      <Dropdown.Item href="#/action-3">110</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="btn-t-edit">
            <button className="btn-transparet">Cancel</button>
            <button className="btn-green">Save</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const pinnedItems: ShortTeamsData[] = [
  { teamId: "*", teamAbbrName: "CC", teamNick: "Command Center", league: "" },
  { teamId: "10*", teamAbbrName: "CC", teamNick: "SeniorBowl / Combine User", league: "" },
];

export default ({
  teamsData,
  activeId,
}: {
  teamsData: Array<ShortTeamsData>;
  activeId: string;
}) => {
  const [modalShow, setModalShow] = useState(false);
  const modalClose = () => setModalShow(false);

  const users = useUsersState();
  const { getUsers } = useUsersDispatch();
  const { getRoles } = useRolesDispatch();
  const { history } = useRouter();

  useEffect(() => {
    getUsers();
    getRoles();
  }, []);

  const isLoaded = Object.keys(users).length > 0;
  const sidebarItems = isLoaded
    ? teamsData.filter((team) => (users[String(team.teamId)] ?? []).length > 0)
    : teamsData;

  useEffect(() => {
    if (!isLoaded) return;
    const activeInSidebar = sidebarItems.some(
      (t) => String(t.teamId) === String(activeId)
    );
    const activeIsPinned = pinnedItems.some(
      (t) => String(t.teamId) === String(activeId)
    );
    if (!activeInSidebar && !activeIsPinned) {
      const redirectTarget =
        sidebarItems.length > 0
          ? sidebarItems[0].teamId
          : pinnedItems[0].teamId;
      history.push(`/customers/${redirectTarget}/users`);
    }
  }, [isLoaded, activeId]);

  return (
    <>
      <Col sm={3}>
        <CustomersSidebar
          items={sidebarItems}
          pinnedItems={pinnedItems}
          activeId={activeId}
          tab={"users"}
        />
      </Col>
      <Col sm={9}>
        <Tab.Content>
          {pinnedItems.map((team) => (
            <Tab.Pane eventKey={team.teamId} key={"tab-pane" + team.teamId}>
              <div className="customer-b-01">
                <div className="b-customer" style={{ paddingBottom: "0" }}>
                  <div className="title-c">
                    <div className="team-tt">{team.teamNick}</div>
                  </div>
                </div>
                <Loader>
                  <div className={"customer-users"}>
                    <UsersTable users={users[String(team.teamId)] || []} teamId={activeId} showRoleFilter={false} />
                  </div>
                </Loader>
              </div>
            </Tab.Pane>
          ))}
          {teamsData.map((team: ShortTeamsData) => {
            return (
              <Tab.Pane eventKey={team.teamId} key={"tab-pane" + team.teamId}>
                <div className="customer-b-01">
                  <div className="b-customer" style={{ paddingBottom: "0" }}>
                    <div className="title-c">
                      <div className="team-tt">
                        <img
                          src={`/assets/images/logos/${team.teamAbbrName}.png`}
                          alt=""
                          height="30px"
                        />
                        {`${team.teamAbbrName} ${team.teamNick}`}
                      </div>
                      <div className="bb-c">
                        <MyVerticallyCenteredModal
                          show={modalShow}
                          onHide={modalClose}
                        />
                        <button
                          className="btn-gray"
                          onClick={() => {
                            setModalShow(true);
                          }}
                          style={{ width: "116px" }}
                        >
                          Edit Team Zones
                        </button>
                        <button className="btn-gray" style={{ width: "128px" }}>
                          Edit Relative Zones
                        </button>
                        <button className="btn-gray" style={{ width: "206px" }}>
                          Edit Max Speed Target by Position
                        </button>
                        <button className="btn-gray" style={{ width: "163px" }}>
                          Edit Position Group Zones
                        </button>
                      </div>
                    </div>
                  </div>
                  <Loader>
                    <div className={"customer-users"}>
                      <UsersTable users={users[String(team.teamId)] || []} teamId={activeId} showRoleFilter={true}  />
                    </div>
                  </Loader>
                </div>
              </Tab.Pane>
            );
          })}
        </Tab.Content>
      </Col>
    </>
  );
};
